export const DEVICE_QUERY_KEY = {
  GET_CARD_FROM_READER: 'GET_CARD_FROM_READER',
};
